import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "MedicalWebPage",
   "@id": "https://www.futurefamilyai.com/fertility/ivf-preparation/#webpage",
   "url": "https://www.futurefamilyai.com/fertility/ivf-preparation/",
   "name": "IVF Preparation & Wellness Tracking | FutureFamilyAI",
   "description": "Prepare for IVF with organized sleep, activity, blood pressure and questions for your fertility team — then keep the same record into pregnancy.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Pooja Patel, MD",
    "jobTitle": "Surrogacy & Fertility Content Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#pooja-patel",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "IVF & Fertility Preparation",
     "item": "https://www.futurefamilyai.com/fertility/ivf-preparation/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "How should I prepare my body for IVF?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Follow your fertility clinic's guidance on testing, medications and supplements. Many clinicians also recommend consistent sleep, moderate activity and managing blood pressure."
     }
    },
    {
     "@type": "Question",
     "name": "Does blood pressure affect IVF?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Uncontrolled high blood pressure can matter for pregnancy health, so many clinics check it before treatment. Ask your clinic whether home readings are useful for you."
     }
    },
    {
     "@type": "Question",
     "name": "Can an app improve my IVF success?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No app can promise that. FutureFamilyAI helps you stay organized and informed; outcomes depend on medical factors your clinic evaluates."
     }
    },
    {
     "@type": "Question",
     "name": "How long before IVF should I start tracking?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Starting one to three months before treatment gives you a useful baseline, but it is never too late to begin."
     }
    },
    {
     "@type": "Question",
     "name": "Can my fertility clinic see my data?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Only if you share it. You can invite your clinic to view trends or a summary."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI work for donor-egg or surrogacy journeys?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. There are pathways for intended parents, egg donors and gestational surrogates."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function FertilityIvfPreparationPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <span>IVF &amp; Fertility Preparation</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                IVF preparation includes medical testing directed by your
                fertility clinic plus everyday habits — sleep, activity, stress
                and blood pressure — that you can track at home.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>IVF patients &amp; planning mothers</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Assisted reproductive technology contributes to roughly 2%
                      of U.S. births each year. (CDC ART Surveillance)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      One record from IVF prep through postpartum · Questions
                      ready for every clinic visit · Works alongside your
                      clinic&apos;s protocol
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">
              PILLAR GUIDE · FERTILITY &amp; IVF
            </span>
            <h1>IVF Preparation — Organize Your Wellness Before Treatment</h1>
            <p className="ffh-answer speakable-content">
              IVF preparation includes medical testing directed by your
              fertility clinic plus everyday habits — sleep, activity, stress
              and blood pressure — that you can track at home. FutureFamilyAI
              organizes those habits and your questions for your fertility team,
              then carries the same record into pregnancy and postpartum. It
              cannot determine fertility or predict IVF success. Start your free
              pilot to prepare with clarity.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#pooja-patel">Dr. Pooja Patel, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=member"
              >
                Request Free Pilot Access
              </Link>
              <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Patient preparing for IVF talking with her fertility clinician"
              >
                <figcaption>
                  <b>Photo slot</b> · Woman in a bright, modern fertility clinic
                  consult room talking with a clinician, notebook and phone on
                  the desk; hopeful, collaborative mood. No screens with text.
                  <br />
                  <b>Alt:</b> Patient preparing for IVF talking with her
                  fertility clinician
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Assisted reproductive technology contributes to roughly 2%
                    of U.S. births each year.
                    <cite>
                      Source:{" "}
                      <a href="https://www.cdc.gov/art/">
                        CDC ART Surveillance
                      </a>
                    </cite>
                  </li>
                  <li>
                    Validated upper-arm devices are recommended for
                    self-measured blood pressure; wrist and finger devices are
                    not recommended for routine use.
                    <cite>
                      Source:{" "}
                      <a href="https://www.ahajournals.org/doi/10.1161/CIR.0000000000000803">
                        AHA/AMA Joint Policy Statement, 2020
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>Why a record matters during IVF</h2>
                <p>
                  IVF involves many appointments, medications and decisions in a
                  short time. A simple daily log of sleep, activity, blood
                  pressure and symptoms helps you answer your clinic&apos;s
                  questions accurately and notice patterns worth raising.
                </p>
              </section>
              <section id="s2">
                <h2>What to track</h2>
                <ul>
                  <li>
                    Blood pressure, especially if you have a history of
                    hypertension.
                  </li>
                  <li>Sleep duration and consistency from your smartwatch.</li>
                  <li>Activity levels your clinic recommends.</li>
                  <li>
                    Medication side effects and questions as they come up.
                  </li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
              <section id="s3">
                <h2>What FutureFamilyAI won&apos;t claim</h2>
                <p>
                  Wellness tracking cannot measure ovarian reserve, predict
                  embryo quality or improve success rates. Your fertility
                  clinic&apos;s testing and protocol come first.
                </p>
              </section>
              <section id="s4">
                <h2>When IVF succeeds, nothing resets</h2>
                <p>
                  Your baseline and history carry straight into pregnancy
                  monitoring, so your obstetric team starts with context from
                  day one.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>How should I prepare my body for IVF?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Follow your fertility clinic&apos;s guidance on testing,
                        medications and supplements. Many clinicians also
                        recommend consistent sleep, moderate activity and
                        managing blood pressure.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Does blood pressure affect IVF?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Uncontrolled high blood pressure can matter for
                        pregnancy health, so many clinics check it before
                        treatment. Ask your clinic whether home readings are
                        useful for you.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can an app improve my IVF success?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        No app can promise that. FutureFamilyAI helps you stay
                        organized and informed; outcomes depend on medical
                        factors your clinic evaluates.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      How long before IVF should I start tracking?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Starting one to three months before treatment gives you
                        a useful baseline, but it is never too late to begin.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can my fertility clinic see my data?</summary>
                    <div className="ffh-ans">
                      <p>
                        Only if you share it. You can invite your clinic to view
                        trends or a summary.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI work for donor-egg or surrogacy
                      journeys?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Yes. There are pathways for intended parents, egg donors
                        and gestational surrogates.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                  <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">PP</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Pooja Patel, MD</h3>
                  <p>
                    Surrogacy &amp; Fertility Content Author, FutureFamilyAI.
                    Dr. Pooja Patel, MD, writes FutureFamilyAI&apos;s surrogacy
                    and fertility content. Her work across the Surrogacy4All
                    network focuses on gestational carriers, IVF preparation and
                    family-building pathways.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/fertility/preconception-wellness-tracking">
                    Preconception Wellness Tracking →
                  </Link>
                  <Link to="/fertility/ivf-blood-pressure-monitoring">
                    Blood Pressure During IVF →
                  </Link>
                  <Link to="/fertility/egg-donor-family-planning">
                    Egg Donor Family Planning →
                  </Link>
                  <Link to="/fertility/canada-ivf-wellness-support">
                    Canada IVF Wellness Support →
                  </Link>
                  <Link to="/fertility/fertility-app-for-couples">
                    Fertility App for Couples →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.eggdonors4all.com">
                    https://www.eggdonors4all.com →
                  </a>
                  <a href="https://www.indianeggdonors.com">
                    https://www.indianeggdonors.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">Why a record matters during IVF</a>
                  </li>
                  <li>
                    <a href="#s2">What to track</a>
                  </li>
                  <li>
                    <a href="#s3">What FutureFamilyAI won&apos;t claim</a>
                  </li>
                  <li>
                    <a href="#s4">When IVF succeeds, nothing resets</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
